import React from "react";

const ImplantationIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 4.325v.01m4-.01v.01m4-.01v.01m4-.01v.01m4-.01v.01M4 20.325v.01m4-.01v.01m4-.01v.01m4-.01v.01m4-.01v.01m0-4.01v.01m0-4.01v.01m0-4.01v.01m-16 7.99v.01m0-4.01v.01m0-4.01v.01m4-.01h8v8H8z"
    ></path>
  </svg>
);

export default ImplantationIcon;
